import { render, staticRenderFns } from "./AuthAction.vue?vue&type=template&id=3272ff23&scoped=true"
import script from "./AuthAction.vue?vue&type=script&lang=js"
export * from "./AuthAction.vue?vue&type=script&lang=js"
import style0 from "./AuthAction.vue?vue&type=style&index=0&id=3272ff23&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3272ff23",
  null
  
)

export default component.exports